import React from 'react';
import BriefingPreview from './components/BriefingPreview';

// Read exercise id from the URL hash query, e.g. #display-briefing?exercise=abc
const getExerciseIdFromHash = () => {
  try {
    const raw = (window.location.hash || '').substring(1);
    const q = raw.split('?')[1];
    if (!q) return null;
    const params = new URLSearchParams(q);
    return params.get('exercise') || params.get('exercise_id') || null;
  } catch (_) {
    return null;
  }
};

const DisplayBriefing = () => {
  const exerciseId = getExerciseIdFromHash();

  if (!exerciseId) {
    return (
      <div className="fixed inset-0 bg-black flex items-center justify-center text-white text-xl">
        No exercise selected. Add <code className="mx-2 text-orange-400">?exercise=&lt;id&gt;</code> to the URL.
      </div>
    );
  }

  return (
    <BriefingPreview
      exerciseId={exerciseId}
      exerciseName=""
      theme={{ colors: {} }}
      onClose={() => window.close()}
      displayMode
    />
  );
};

export default DisplayBriefing;
